import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import getApplicationSettings from 'owa-application-settings/lib/selectors/getApplicationSettings';
import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { isGlobalSettingsMailbox } from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';

export const prefetchSSRTokenUtil = async (mInfo: MailboxInfo): Promise<void> => {
    const dp = new PerformanceDatapoint('OutlookCopilotChat_SSR_TokenAcquisition', mInfo);
    const requestId = getGuid();
    const isPrimaryAccount = isGlobalSettingsMailbox(mInfo);
    dp.addCustomData({ requestId, isPrefetch: true, isPrimaryAccount });
    const ocdiEndpoint = getApplicationSettings('BizchatOcdiEndpoint', mInfo);
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(
        ocdiEndpoint.resourceUrl,
        'BizchatSSRToken' /* apiName */,
        requestId,
        undefined /* targetTenantId */,
        undefined /* wwwAuthenticateHeader */,
        true /* showFullTokenResponse */,
        true /* preferIdpToken */,
        mInfo
    );
    let isTokenFromCache = false;
    if (!!token && typeof token === 'string') {
        isTokenFromCache = true;
    }
    dp?.addCustomData({ isTokenFromCache });

    if (!token) {
        token = await tokenPromise;
    }

    if (!!token) {
        if (typeof token === 'object') {
            if (token?.accessToken) {
                dp?.end();
            }
            if (token?.error) {
                dp?.endWithError(
                    DatapointStatus.ServerError,
                    new Error('Failed to acquire token for bizchat')
                );
            }
        }
        if (typeof token === 'string') {
            dp?.end();
        }
    }

    dp.endWithError(DatapointStatus.ServerError, new Error('Failed to acquire token for bizchat'));
};
